import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';
import ApplicationIcon from 'components/standard/ApplicationIcon';
import OSIcon from 'components/standard/OSIcon';
import Box from '@liquidweb-dev/undercurrent/Box';
import Label from './Label';

const OS = ({
	os,
	variant,
}: {
	os: string | undefined;
	variant: 'card' | 'row';
}) => {
	const osIcon = (
		<OSIcon
			os={os || null}
			sx={({ size }) => ({
				height: size.xS,
				width: size.xS,
				flexShrink: 0,
			})}
		/>
	);

	if (variant === 'row' && !os) {
		return <Label>No OS</Label>;
	}

	if (variant === 'row') {
		return (
			<Tooltip
				title={os}
				placement="bottom"
				arrow
				sx={{ display: 'inline-flex', p: 50, m: -50 }}
			>
				<Box>{osIcon}</Box>
			</Tooltip>
		);
	}

	return (
		<>
			{osIcon}
			<Label>{os || 'No OS'}</Label>
		</>
	);
};

const Application = ({ application }: { application: string }) => (
	<>
		<ApplicationIcon
			application={application}
			sx={({ size }) => ({
				height: size.xS,
				width: size.xS,
				flexShrink: 0,
			})}
		/>
		<Label>{application}</Label>
	</>
);

export interface ApplicationOrOSProps {
	os: string | undefined;
	application: string | null | undefined;
	variant: 'card' | 'row';
}

const ApplicationOrOS = ({
	os,
	application,
	variant,
}: ApplicationOrOSProps) => {
	if (application) {
		return <Application application={application} />;
	}

	return <OS os={os} variant={variant} />;
};

export default ApplicationOrOS;
